import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InvoicesDataProvider } from '../../../../../shared/services/invoice/invoices-data-service/invoices.data.service';
import { MessageService } from '../../../../../shared/services/helpers/message-service/message.service';
import { InvoiceServiceProvider } from '../../../../../shared/services/invoice/invoice-service/invoice.service';
import { Subject } from 'rxjs/Subject';
import {
	InvoicesOverviewRequest,
	InvoiceViewBlock,
	PTInvoiceLayout,
	SPInvoiceLayout
} from '@models/invoice.model';
import { filter, finalize, takeUntil } from 'rxjs/operators';

@Component({
	selector: 'invoices-view-block',
	template: require('./invoices-view-block.component.html'),
	styles: [require('./invoices-view-block.component.scss')]
})
export class InvoicesViewBlockComponent implements OnInit {
	@Input('leadId') leadId: number = null;
	@Input('isArchived') isArchived: boolean;
	@Output('sendInvoiceEvent')
	sendInvoiceEvent: EventEmitter<any> = new EventEmitter<any>();
	@Output('createNewInvoiceEvent')
	createNewInvoiceEvent: EventEmitter<any> = new EventEmitter<any>();
	shootProofInvoiceLayout: SPInvoiceLayout;
	picTimeInvoiceLayout: PTInvoiceLayout;
	selectedInvoiceId: number;
	showLoadingBlock = true;
	invoicesSN: Array<InvoiceViewBlock> = [];
	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private invoiceDataService: InvoicesDataProvider,
		private messageService: MessageService,
		private invoiceService: InvoiceServiceProvider
	) {}

	_jobId: number;

	get jobId() {
		return this._jobId;
	}

	@Input('jobId')
	set jobId(value) {
		if (value) {
			this._jobId = value;
			this.getInvoicesOverview();
		}
	}

	ngOnInit(): void {
		this.shouldUpdateInvoiceObservable();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
		this.invoiceDataService.destroyInvoiceUpdatedObservable();
	}

	getInvoicesOverview(): void {
		this.invoiceDataService
			.getInvoiceOverviewV1(this.jobId)
			.pipe(
				takeUntil(this.unsubscribe),
				finalize(() => (this.showLoadingBlock = false))
			)
			.subscribe(
				(data: InvoicesOverviewRequest) => this.succesGetInvoicesOverview(data),
				error => this.messageService.showDefaultErrorMessage(error)
			);
	}

	sendInvoice(invoiceId: number): void {
		this.sendInvoiceEvent.emit(invoiceId);
	}

	createNewInvoice(): void {
		this.leadId !== null
			? this.createNewInvoiceEvent.emit(this.leadId)
			: this.createNewInvoiceEvent.emit(this.jobId);
	}

	private shouldUpdateInvoiceObservable(): void {
		this.invoiceDataService.shouldInvoiceBeUpdatedObservable
			.pipe(
				takeUntil(this.unsubscribe),
				filter(value => !!value && value === 'UPDATE_PT_INVOICES')
			)
			.subscribe(() => this.getInvoicesOverview());
	}

	private succesGetInvoicesOverview(data: InvoicesOverviewRequest): void {
		const {
			shootProofInvoiceLayout,
			snInvoiceLayout,
			fundyInvoiceLayout,
			picTimeInvoiceLayout
		} = data.data;

		this.shootProofInvoiceLayout = shootProofInvoiceLayout;
		this.picTimeInvoiceLayout = picTimeInvoiceLayout;

		if (
			fundyInvoiceLayout !== null &&
			fundyInvoiceLayout.invoices.length !== 0
		) {
			const mergedInvoices = snInvoiceLayout.invoices.concat(
				fundyInvoiceLayout.invoices
			);
			snInvoiceLayout.invoices = mergedInvoices;
		}

		this.invoicesSN = this.invoiceService.setFormattedDaysToDue(
			JSON.parse(JSON.stringify(snInvoiceLayout.invoices))
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/invoices/invoices-view-block/invoices-view-block.component.ts